import { Card } from "@/components/ui/card";

const TemplateCardSkeleton = () => {
  return (
    <Card className="overflow-hidden border border-border/50">
      <div className="relative">
        <div className="p-6">
          {/* Header with title and badge */}
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1 min-w-0">
              <div className="h-6 bg-muted rounded animate-pulse w-3/4 mb-2"></div>
              <div className="h-4 bg-muted rounded-full animate-pulse w-24"></div>
            </div>
            <div className="h-8 w-8 bg-muted rounded animate-pulse"></div>
          </div>

          {/* Description */}
          <div className="space-y-2 mb-4">
            <div className="h-3 bg-muted rounded animate-pulse w-full"></div>
            <div className="h-3 bg-muted rounded animate-pulse w-5/6"></div>
            <div className="h-3 bg-muted rounded animate-pulse w-4/6"></div>
          </div>

          {/* Footer */}
          <div className="pt-3 border-t border-muted">
            <div className="h-3 bg-muted rounded animate-pulse w-32"></div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default TemplateCardSkeleton;
